import { ReactElement } from 'react'
import { Checkbox, FormControlLabel } from '@mui/material'
import { Section } from '@ui2/structure'

interface Props {
  showTemplate: boolean
  onShowTemplateChange: (showTemplate: boolean) => void
  /** The template image is generated on first use; don't let it be toggled mid-flight. */
  isLoadingTemplate: boolean
}

/** "Ansicht" section: display options of the scene preview (e.g. the plan template underneath). */
const PlanViewDisplaySection = ({
  showTemplate,
  onShowTemplateChange,
  isLoadingTemplate,
}: Props): ReactElement => (
  <Section title="Ansicht" collapsible hideBorderBottom>
    <FormControlLabel
      control={
        <Checkbox
          size="small"
          checked={showTemplate}
          disabled={isLoadingTemplate}
          onChange={event => onShowTemplateChange(event.target.checked)}
        />
      }
      label="Vorlage anzeigen"
      data-cy="plan-view-show-template-checkbox"
    />
  </Section>
)

export default PlanViewDisplaySection
